export default __webpack_public_path__ + "static/media/bofa.16cc26cf.svg";